import React, { Component, Fragment } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { hot } from 'react-hot-loader';
import ErrorBoundary from '@surfline/quiver-react/dist/ErrorBoundary';
import initializeAnonymousId from '../../utils/initializeAnonymousId';
import config from '../../config';

import { Create, Login, ForgotPassword, VerifyEmail } from '../../containers';
import { LeftRail, RightRail, RegistrationCTA } from '../../components';

class App extends Component {
  constructor(props) {
    super(props);
    const {
      identity
    } = props;
    initializeAnonymousId(identity, 'registration');
  }

  render() {
    return (
      <ErrorBoundary>
        <div className="registration-container">
          <div className="registration__mobile-header" />
          <LeftRail>
            <Switch>
              <Route path="/create-account" component={Create} />
              <Route path="/sign-in" component={Login} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/verify-email" component={VerifyEmail} />
              {config.company === 'sl' ? (
                <Fragment>
                  <Route
                    path="/setup/create-account"
                    render={() => <Redirect to="/create-account" />}
                  />
                  <Route
                    path="/setup/sign-in"
                    render={() => <Redirect to="/sign-in" />}
                  />
                </Fragment>
              ) : null}
            </Switch>
          </LeftRail>
          <RightRail>
            <RegistrationCTA />
          </RightRail>
        </div>
      </ErrorBoundary>
    );
  }
}

export default hot(module)(App);
